/**
 * The web and desktop binding of `@aegis/api-client`.
 *
 * The client itself, the wire types and the display formatters moved into a
 * package so React Native can share them. What stays here is the part that is
 * genuinely local: how *this* platform answers the three questions in `ApiHost`
 * — where the server is, how a session is carried, and how this device
 * identifies itself.
 *
 * This module re-exports the package wholesale, so every existing
 * `from '../lib/api.js'` import keeps working and call sites did not change when
 * the code moved. New code on this platform can import from either; new code on
 * mobile must import from the package.
 */
import { createApi } from '@aegis/api-client';
import { authHeaders, deviceHint } from './credentials.js';
import { url } from './runtime.js';

const client = createApi({ url, authHeaders, deviceHint });

export const api = client.api;
export const setUnauthenticatedHandler = client.setUnauthenticatedHandler;

export * from '@aegis/api-client';
